(function(){
  var root=document.getElementById('egx'); if(!root) return;
  var $$=function(s){return [].slice.call(root.querySelectorAll(s))};

  /* color picker -> each bundle card links straight to checkout for that color */
  var map={};
  try{JSON.parse(document.getElementById('egx-vmap').textContent).forEach(function(v){(map[v.c]=map[v.c]||{})[v.k]=v})}catch(e){}
  var cards=$$('[data-pack]'),btns=$$('.egx-pick button');
  function setColor(c){
    btns.forEach(function(b){b.setAttribute('aria-pressed',b.dataset.c===c?'true':'false')});
    cards.forEach(function(card){
      var v=map[c]&&map[c][card.dataset.pack]; if(!v) return;
      var go=card.querySelector('.go'),more=card.querySelector('.more');
      if(!go.dataset.l) go.dataset.l=go.innerHTML;
      more.href='/products/memory-orb?variant='+v.id;
      if(v.a){go.href='/cart/'+v.id+':1';go.innerHTML=go.dataset.l;go.style.opacity=''}
      else{go.removeAttribute('href');go.textContent='Sold out in '+c;go.style.opacity='.5'}
    });
  }
  btns.forEach(function(b){b.addEventListener('click',function(){setColor(b.dataset.c)})});
  if(btns.length) setColor('White');

  /* first-screen CTA: copy the hero button under the headline so it's visible on load
     (the bottom CTA sits below the fold until the header scrolls away), then hand off */
  var hero=root.querySelector('[data-hero]'),topL=hero&&hero.querySelector('.line.top'),cta=hero&&hero.querySelector('.line.cta');
  if(topL&&cta){var box=document.createElement('div');box.style.cssText='margin-top:26px;pointer-events:auto';
    [].slice.call(cta.children).forEach(function(n){box.appendChild(n.cloneNode(true))});topL.appendChild(box);cta.dataset.in='0.36';cta.style.opacity=0;cta.style.visibility='hidden';window.dispatchEvent(new Event('scroll'))}

  /* in-page jumps to the bundles */
  var buy=document.getElementById('egx-buy');
  document.querySelectorAll('a[href="#egx-buy"]').forEach(function(a){a.addEventListener('click',function(e){if(!buy)return;e.preventDefault();buy.scrollIntoView({behavior:'smooth',block:'start'})})});

  /* sticky buy bar: shows after the first screen, hides while bundles or final CTA are on screen */
  var bar=root.querySelector('.egx-bar'),end=root.querySelector('.egx-end'),inBuy=false,inEnd=false,shown=false;
  if(!bar) return;
  function upd(){var on=window.scrollY>window.innerHeight*0.9&&!inBuy&&!inEnd;if(on!==shown){shown=on;bar.classList.toggle('on',on)}}
  var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.target===buy)inBuy=e.isIntersecting;if(e.target===end)inEnd=e.isIntersecting});upd()},{threshold:0.12});
  if(buy)io.observe(buy); if(end)io.observe(end);
  window.addEventListener('scroll',upd,{passive:true}); upd();
})();
